import type { JSX } from 'react';

import { Image } from '@change/ds-core-ui';

type Props = Readonly<{
	id: string;
	url: string;
	mobileUrl: string;
}>;

export function PhotoMobile({ id, url, mobileUrl }: Props): JSX.Element {
	return (
		<div className="relative w-full">
			<Image aspectRatio="16:9" id={id} src={mobileUrl || url} alt="" className="w-full align-top" />
		</div>
	);
}
